import { apiBase } from './config';
const SERVER_PATH = apiBase;
export default class APIConstant {
  static path = {

    // Auth API

    login: `${SERVER_PATH}/authentication/loginUser`,
    checkLoginIdentifier: `${SERVER_PATH}/authentication/checkLoginIdentifier`,
    refreshToken: `${SERVER_PATH}/authentication/refreshToken`,
    logout: `${SERVER_PATH}/authentication/logoutUser`,
    deleteSession: `${SERVER_PATH}/session/deleteUserSessionById`,
    deleteSessionById: `${SERVER_PATH}/session/deleteSessionById`,
    getMySessions: `${SERVER_PATH}/session/getMySessions`,
    logoutMySession: `${SERVER_PATH}/session/logoutMySession`,
    updatePassword: `${SERVER_PATH}/authentication/updateUserPassword`,
    getStaffPickList: `${SERVER_PATH}/authentication/getStaffPickList`,
    GoogleMapApiKey: 'AIzaSyDP5zdRgV8rsNSbxZp-f8NkNQQ9YoMMARM', //'AIzaSyAww6TxPSzQbg74ljJahxvuLHmRfICHbf4',

    //Sidebar API
    getUserMenu: `${SERVER_PATH}/menu/getMenuItems`,
    saveUserMenuOrder: `${SERVER_PATH}/menu/saveUserMenuOrder`,
    getUserType: `${SERVER_PATH}/useraccess/getUserType`,
    getMenuMaster: `${SERVER_PATH}/useraccess/getMenuMaster`,
    addUpdateUserType: `${SERVER_PATH}/useraccess/addUpdateUserType`,
    getUserTypeByID: `${SERVER_PATH}/useraccess/getUserTypeByID`,
    getUserWiseAccessList: `${SERVER_PATH}/userAccess/getUserAccessList`,

    // Add plan 
    getUserPlanList: `${SERVER_PATH}/userPlan/getUserPlanList`,

    //  user 
    AddUpdateUser: `${SERVER_PATH}/authentication/addUsers`,
    getUser: `${SERVER_PATH}/authentication/getUsers`,
    getUserById: `${SERVER_PATH}/authentication/getUserById`,
    updateUserStatus: `${SERVER_PATH}/authentication/updateUserStatus`,
    AddUpdateStudent: `${SERVER_PATH}/authentication/addUpdateStudent`,
    UpdateBuildConfigurationById: `${SERVER_PATH}/authentication/updateBuildConfigurationById`,
    UpdateBulkProfilePhoto: `${SERVER_PATH}/authentication/updateBulkProfilePhoto`,
    sendOTP: `${SERVER_PATH}/authentication/sendOtp`,
    verifyOTPLogin: `${SERVER_PATH}/authentication/verifyOtpLogin`,


    GetStringMap: `${SERVER_PATH}/stringMap/getStringMapList`,
    GetUserRole: `${SERVER_PATH}/userRole/getUserRoleList`,
    getExamTypeList: `${SERVER_PATH}/examTypeMaster/getExamTypeDetailList`,

    //Class Master
    AddUpdateClassMaster: `${SERVER_PATH}/classMaster/addClassDetail`,
    getClassList: `${SERVER_PATH}/classMaster/getClassDetailList`,
    GetClassConfigStudentDetail: `${SERVER_PATH}/classMaster/getClassConfigStudentDetail`,
    updateClassDetailStatus: `${SERVER_PATH}/classMaster/updateClassDetailStatus`,
    deleteClassDetail: `${SERVER_PATH}/classMaster/deleteClassDetail`,
    GetStudentIdCardData: `${SERVER_PATH}/classMaster/getStudentIdCardData`,
    GetStaffIdCardData: `${SERVER_PATH}/classMaster/getStaffIdCardData`,
    GetStudentResultData: `${SERVER_PATH}/classMaster/getStudentResultData`,

    //Class No Master
    AddUpdateClassNoMaster: `${SERVER_PATH}/classNoMaster/addClassNoDetail`,
    getClassNoList: `${SERVER_PATH}/classNoMaster/getClassNoDetailList`,
    updateClassNoDetailStatus: `${SERVER_PATH}/classNoMaster/updateClassNoDetailStatus`,
    deleteClassNoDetail: `${SERVER_PATH}/classNoMaster/deleteClassNoDetail`,

    //Section Master
    AddUpdateSectionMaster: `${SERVER_PATH}/sectionMaster/addSectionDetail`,
    getSectionList: `${SERVER_PATH}/sectionMaster/getSectionDetailList`,
    updateSectionDetailStatus: `${SERVER_PATH}/sectionMaster/updateSectionDetailStatus`,
    deleteSectionDetail: `${SERVER_PATH}/sectionMaster/deleteSectionDetail`,

    //Teacher Master
    AddPersonalDetail: `${SERVER_PATH}/personalDetail/addPersonalDetail`,
    GetPersonalDetailById: `${SERVER_PATH}/personalDetail/getPersonalDetailById`,
    AddQualificationDetail: `${SERVER_PATH}/qualificationDetail/addQualificationDetail`,
    GetQualificationDetailById: `${SERVER_PATH}/qualificationDetail/getQualificationDetailById`,

    // Student Master
    AddAdmissionDetail: `${SERVER_PATH}/admissionDetail/addAdmissionDetail`,
    GetAdmissionDetailById: `${SERVER_PATH}/admissionDetail/getAdmissionDetailById`,
    AddPreviousSchoolDetail: `${SERVER_PATH}/previousSchoolDetail/addPreviousSchoolDetail`,
    GetPreviousSchoolDetailById: `${SERVER_PATH}/previousSchoolDetail/getPreviousSchoolDetailById`,
    getStudentStatusList: `${SERVER_PATH}/studentStatusMaster/getStudentStatusList`,
    BulkUpdateAdmissionDetail: `${SERVER_PATH}/admissionDetail/bulkUpdateAdmissionDetail`,
    //House Master
    AddUpdateHouseMaster: `${SERVER_PATH}/houseMaster/addHouseDetail`,
    getHouseList: `${SERVER_PATH}/houseMaster/getHouseDetailList`,
    updateHouseDetailStatus: `${SERVER_PATH}/houseMaster/updateHouseDetailStatus`,
    deleteHouseDetail: `${SERVER_PATH}/houseMaster/deleteHouseDetail`,

    //Class Configuration
    AddUpdateClassConfiguration: `${SERVER_PATH}/classConfiguration/addClassConfiguration`,
    getClassConfigurationData: `${SERVER_PATH}/classConfiguration/getClassConfigurationData`,
    getClassConfigurationList: `${SERVER_PATH}/classConfiguration/getClassConfigurationList`,
    getStudentDetailList: `${SERVER_PATH}/classConfiguration/getStudentDetailList`,
    getSearchedStudentDetailList: `${SERVER_PATH}/classConfiguration/getSearchedStudentDetailList`,
    getStudentDropDownList: `${SERVER_PATH}/classConfiguration/getStudentDropDownList`,
    updateClassConfigurationStatus: `${SERVER_PATH}/classConfiguration/updateClassConfigurationStatus`,
    getParentDetailList: `${SERVER_PATH}/classConfiguration/getParentDetailList`,
    getTeacherDetailList: `${SERVER_PATH}/classConfiguration/getTeacherDetailList`,
    getParentDropDownList: `${SERVER_PATH}/classConfiguration/getParentDropDownList`,
    updateParentStatus: `${SERVER_PATH}/classConfiguration/updateParentStatus`,
    deleteParent: `${SERVER_PATH}/classConfiguration/deleteParent`,
    updateStudentStatus: `${SERVER_PATH}/classConfiguration/updateStudentStatus`,
    deleteStudent: `${SERVER_PATH}/classConfiguration/deleteStudent`,
    updateTeacherStatus: `${SERVER_PATH}/classConfiguration/updateTeacherStatus`,
    deleteTeacher: `${SERVER_PATH}/classConfiguration/deleteTeacher`,
    getChildreenDropDownList: `${SERVER_PATH}/classConfiguration/getChildreenDropDownList`,
    ImportStudents: `${SERVER_PATH}/classConfiguration/importStudents`,
    getChildreenDetailList: `${SERVER_PATH}/classConfiguration/getChildreenDetailList`,
    ImportParents: `${SERVER_PATH}/classConfiguration/importParents`,
    ImportTeachers: `${SERVER_PATH}/classConfiguration/importTeachers`,
    GenerateTeacherSample: `${SERVER_PATH}/classConfiguration/generateTeacherSample`,
    GenerateStudentSample: `${SERVER_PATH}/classConfiguration/generateStudentSample`,
    ExportStudents: `${SERVER_PATH}/classConfiguration/exportStudents`,
    GenerateParentSample: `${SERVER_PATH}/classConfiguration/generateParentSample`,
    ImportSubjects: `${SERVER_PATH}/classConfiguration/importSubjects`,
    GenerateSubjectSample: `${SERVER_PATH}/classConfiguration/generateSubjectSample`,


    //Board Master
    AddUpdateBoardMaster: `${SERVER_PATH}/boardMaster/addBoardDetail`,
    getBoardList: `${SERVER_PATH}/boardMaster/getBoardDetailList`,

    //Id Card Configuration
    AddUpdateIdCardConfig: `${SERVER_PATH}/idCardConfiguration/addIdCardConfiguration`,
    GetIdCardConfigurationList: `${SERVER_PATH}/idCardConfiguration/getIdCardConfigurationList`,
    UpdateIdCardConfigurationStatus: `${SERVER_PATH}/idCardConfiguration/updateIdCardConfigurationStatus`,
    DeleteIdCardConfiguration: `${SERVER_PATH}/idCardConfiguration/deleteIdCardConfiguration`,

    //School Detail
    AddSchoolDetail: `${SERVER_PATH}/schoolDetail/addSchoolDetail`,
    GetSchoolDetailById: `${SERVER_PATH}/schoolDetail/getSchoolDetailById`,

    //Subject Master
    AddUpdateSubjectMaster: `${SERVER_PATH}/subjectMaster/addSubjectDetail`,
    getSubjectList: `${SERVER_PATH}/subjectMaster/getSubjectDetailList`,
    getSubjectByClassId: `${SERVER_PATH}/subjectMaster/getSubjectByClassId`,
    updateSubjectDetailStatus: `${SERVER_PATH}/subjectMaster/updateSubjectDetailStatus`,
    deleteSubjectDetail: `${SERVER_PATH}/subjectMaster/deleteSubjectDetail`,
    generateDynamicId: `${SERVER_PATH}/subjectMaster/generateDynamicId`,
    getLanguageList: `${SERVER_PATH}/languageMaster/getLanguageDetailList`,
    getBloodList: `${SERVER_PATH}/bloodMaster/getBloodDetailList`,
    getCasteList: `${SERVER_PATH}/casteMaster/getCasteDetailList`,
    getPhCategoryList: `${SERVER_PATH}/phCategoryMaster/getPhCategoryDetailList`,
    getReligionList: `${SERVER_PATH}/religionMaster/getReligionDetailList`,

    addUpdateProfileConfiguration: `${SERVER_PATH}/profileConfiguration/addUpdateProfileConfiguration`,
    getProfileConfigurationList: `${SERVER_PATH}/profileConfiguration/getProfileConfigurationList`,

    //Academic Calender
    AddUpdateAcademicCalander: `${SERVER_PATH}/academicCalander/addAcademicCalanderConfiguration`,
    getAcademicCalanderTemplateList: `${SERVER_PATH}/academicCalander/getAcademicCalanderConfigurationList`,
    deleteAcademicCalanderTemplate: `${SERVER_PATH}/academicCalander/deleteAcademicCalanderConfiguration`,
    getAcademicCalanderConfigurationById: `${SERVER_PATH}/academicCalander/getAcademicCalanderConfigurationById`,
    getAcademicCalanderClassList: `${SERVER_PATH}/academicCalander/getAcademicCalanderClassList`,
    getAcademicCalanderSpecificList: `${SERVER_PATH}/academicCalander/getAcademicCalanderSpecificList`,
    getAcademicSpecificCalanderById: `${SERVER_PATH}/academicCalander/getAcademicSpecificCalanderById`,
    AddUpdateAcademicSpecificCalander: `${SERVER_PATH}/academicCalander/addAcademicSpecificCalander`,
    deleteAcademicSpecificCalander: `${SERVER_PATH}/academicCalander/deleteAcademicSpecificCalander`,


    //Time Table
    AddUpdateTimeTableEntry: `${SERVER_PATH}/timeTable/addUpdateTimeTableEntry`,
    GetTimeTableByClass: `${SERVER_PATH}/timeTable/getTimeTableByClass`,
    AddUpdateTeacherTimeTableEntry: `${SERVER_PATH}/timeTable/addUpdateTeacherTimeTableEntry`,
    GetTimeTableByTeacher: `${SERVER_PATH}/timeTable/getTimeTableByTeacher`,
    GetTimeTableListByClass: `${SERVER_PATH}/timeTable/getTimeTableListByClass`,
    GetTimeTableListByTeacher: `${SERVER_PATH}/timeTable/getTimeTableListByTeacher`,
    GetParentDashboardData: `${SERVER_PATH}/timeTable/getParentDashboardData`,
    DeleteClassTimeTable: `${SERVER_PATH}/timeTable/deleteClassTimeTable`,
    DeleteTeacherTimeTable: `${SERVER_PATH}/timeTable/deleteTeacherTimeTable`,


    // Shift Master
    AddUpdateShiftMaster: `${SERVER_PATH}/shiftMaster/addShiftDetail`,
    getShiftList: `${SERVER_PATH}/shiftMaster/getShiftDetailList`,
    updateShiftDetailStatus: `${SERVER_PATH}/shiftMaster/updateShiftDetailStatus`,
    deleteShiftDetail: `${SERVER_PATH}/shiftMaster/deleteShiftDetail`,

    // Leave Reason Master
    AddUpdateLeaveReasonMaster: `${SERVER_PATH}/leaveReasonMaster/addLeaveReasonDetail`,
    getLeaveReasonList: `${SERVER_PATH}/leaveReasonMaster/getLeaveReasonDetailList`,
    updateLeaveReasonDetailStatus: `${SERVER_PATH}/leaveReasonMaster/updateLeaveReasonDetailStatus`,
    DeleteLeaveReasonDetail: `${SERVER_PATH}/leaveReasonMaster/deleteLeaveReasonDetail`,

    // Theme Master
    AddUpdateThemeMaster: `${SERVER_PATH}/themeMaster/addThemeMaster`,
    getGlobalThemeList: `${SERVER_PATH}/themeMaster/getThemeMasterList`,
    getCustomThemeList: `${SERVER_PATH}/themeMaster/getCustomThemeList`,
    getActiveTheme: `${SERVER_PATH}/themeMaster/getActiveTheme`,
    setActiveTheme: `${SERVER_PATH}/themeMaster/setActiveTheme`,
    clearActiveTheme: `${SERVER_PATH}/themeMaster/clearActiveTheme`,
    updateThemeMasterStatus: `${SERVER_PATH}/themeMaster/updateThemeMasterStatus`,
    deleteThemeMaster: `${SERVER_PATH}/themeMaster/deleteThemeMaster`,

    // Fee Master
    AddUpdateFeeMaster: `${SERVER_PATH}/feeMaster/addFeeDetail`,
    getFeeList: `${SERVER_PATH}/feeMaster/getFeeDetailList`,
    updateFeeDetailStatus: `${SERVER_PATH}/feeMaster/updateFeeDetailStatus`,
    deleteFeeDetail: `${SERVER_PATH}/feeMaster/deleteFeeDetail`,

    // Staff Attendance
    GetStaffAttendanceList: `${SERVER_PATH}/staffAttendance/getStaffAttendanceList`,
    AddStaffAttendanceDetail: `${SERVER_PATH}/staffAttendance/addStaffAttendanceDetail`,
    GetStaffAttendanceReport: `${SERVER_PATH}/staffAttendance/getStaffAttendanceReport`,
    ImportStaffAttendance: `${SERVER_PATH}/staffAttendance/importStaffAttendance`,
    GenerateStaffAttendanceSample: `${SERVER_PATH}/staffAttendance/generateStaffAttendanceSample`,

    // Attendance
    GetAttendanceListByClass: `${SERVER_PATH}/attendance/getAttendanceList`,
    AddAttendanceDetail: `${SERVER_PATH}/attendance/addAttendanceDetail`,
    ImportAttendance: `${SERVER_PATH}/attendance/importAttendance`,
    GenerateAttendanceSample: `${SERVER_PATH}/attendance/generateAttendanceSample`,
    GetAttendanceClassList: `${SERVER_PATH}/attendance/getAttendanceClassList`,
    GetClassWiseAttendanceList: `${SERVER_PATH}/attendance/getClassWiseAttendanceList`,
    GetStudentWiseAttendanceList: `${SERVER_PATH}/attendance/getStudentWiseAttendanceList`,
    GetParentWiseAttendanceList: `${SERVER_PATH}/attendance/getParentWiseAttendanceList`,
    GetParentWiseAttendanceOverall: `${SERVER_PATH}/attendance/getParentWiseAttendanceOverall`,
    markStaffAttendanceByGps: `${SERVER_PATH}/staffGpsAttendance/markStaffAttendanceByGps`,
    getMyTodayGpsStatus: `${SERVER_PATH}/staffGpsAttendance/getMyTodayGpsStatus`,

    //Term Master
    AddUpdateTermMaster: `${SERVER_PATH}/termMaster/addTermDetail`,
    getTermList: `${SERVER_PATH}/termMaster/getTermDetailList`,
    updateTermDetailStatus: `${SERVER_PATH}/termMaster/updateTermDetailStatus`,
    deleteTermDetail: `${SERVER_PATH}/termMaster/deleteTermDetail`,

    //Stop Master
    AddUpdateStopMaster: `${SERVER_PATH}/stopMaster/addStopDetail`,
    getStopList: `${SERVER_PATH}/stopMaster/getStopDetailList`,
    updateStopDetailStatus: `${SERVER_PATH}/stopMaster/updateStopDetailStatus`,
    deleteStopDetail: `${SERVER_PATH}/stopMaster/deleteStopDetail`,

    //Grade Master
    AddUpdateGradeMaster: `${SERVER_PATH}/gradeMaster/addGradeDetail`,
    getGradeList: `${SERVER_PATH}/gradeMaster/getGradeDetailList`,
    updateGradeDetailStatus: `${SERVER_PATH}/gradeMaster/updateGradeDetailStatus`,
    deleteGradeDetail: `${SERVER_PATH}/gradeMaster/deleteGradeDetail`,

    //Co-Scholastic Master
    AddUpdateCoScholasticMaster: `${SERVER_PATH}/coScholasticMaster/addCoScholasticDetail`,
    getCoScholasticList: `${SERVER_PATH}/coScholasticMaster/getCoScholasticDetailList`,
    updateCoScholasticDetailStatus: `${SERVER_PATH}/coScholasticMaster/updateCoScholasticDetailStatus`,
    deleteCoScholasticDetail: `${SERVER_PATH}/coScholasticMaster/deleteCoScholasticDetail`,

    //Result Template
    AddUpdateResultTemplate: `${SERVER_PATH}/resultTemplate/addResultTemplate`,
    GetResultTemplateList: `${SERVER_PATH}/resultTemplate/getResultTemplateList`,
    GetResultTemplateListByClassId: `${SERVER_PATH}/resultTemplate/getResultTemplateListByClassId`,
    DeleteResultTemplate: `${SERVER_PATH}/resultTemplate/deleteResultTemplate`,
    GetStudentResultDataByParent: `${SERVER_PATH}/resultTemplate/getStudentResultDataByParent`,

    //Type Master
    AddUpdateTypeMaster: `${SERVER_PATH}/typeMaster/addTypeDetail`,
    getTypeList: `${SERVER_PATH}/typeMaster/getTypeDetailList`,
    updateTypeDetailStatus: `${SERVER_PATH}/typeMaster/updateTypeDetailStatus`,
    deleteTypeDetail: `${SERVER_PATH}/typeMaster/deleteTypeDetail`,

    //CoScholastic Template
    AddUpdateCoScholasticTemplate: `${SERVER_PATH}/coScholasticTemplate/addCoScholasticTemplate`,
    GetCoScholasticTemplateList: `${SERVER_PATH}/coScholasticTemplate/getCoScholasticTemplateList`,
    UpdateCoScholasticTemplateStatus: `${SERVER_PATH}/coScholasticTemplate/updateCoScholasticTemplateStatus`,
    DeleteCoScholasticTemplate: `${SERVER_PATH}/coScholasticTemplate/deleteCoScholasticTemplate`,

    //CoScholastic Grade Template
    AddUpdateCoScholasticGradeTemplate: `${SERVER_PATH}/coScholasticGradeTemplate/addCoScholasticGradeTemplate`,
    GetCoScholasticGradeTemplateList: `${SERVER_PATH}/coScholasticGradeTemplate/getCoScholasticGradeTemplateList`,
    UpdateCoScholasticGradeTemplateStatus: `${SERVER_PATH}/coScholasticGradeTemplate/updateCoScholasticGradeTemplateStatus`,
    DeleteCoScholasticGradeTemplate: `${SERVER_PATH}/coScholasticGradeTemplate/deleteCoScholasticGradeTemplate`,
    GetCoScholasticGradesList: `${SERVER_PATH}/coScholasticGradeTemplate/getCoScholasticGradesList`,

    // Grade Entry
    AddUpdateGradingEntry: `${SERVER_PATH}/gradeEntry/addGradeEntryDetail`,
    GetGradeEntryList: `${SERVER_PATH}/gradeEntry/getGradeEntryDetailList`,

    // Room Master
    AddUpdateRoomMaster: `${SERVER_PATH}/roomMaster/addRoomDetail`,
    getRoomList: `${SERVER_PATH}/roomMaster/getRoomDetailList`,
    updateRoomDetailStatus: `${SERVER_PATH}/roomMaster/updateRoomDetailStatus`,
    deleteRoomDetail: `${SERVER_PATH}/roomMaster/deleteRoomDetail`,

    // Exam Schedule
    AddUpdateExamSchedule: `${SERVER_PATH}/examSchedule/addExamScheduleDetail`,
    GetExamScheduleList: `${SERVER_PATH}/examSchedule/getExamScheduleDetailList`,
    updateExamScheduleDetailStatus: `${SERVER_PATH}/examSchedule/updateExamScheduleDetailStatus`,
    DeleteExamScheduleDetail: `${SERVER_PATH}/examSchedule/deleteExamScheduleDetail`,
    GetExamScheduleMarksList: `${SERVER_PATH}/examSchedule/getExamScheduleMarksDetailList`,

    // Hall Ticket
    AddUpdateHallTicketTemplate: `${SERVER_PATH}/hallTicket/addHallTicketTemplate`,
    GetHallTicketTemplateList: `${SERVER_PATH}/hallTicket/getHallTicketTemplateList`,
    GetHallTicketTemplateById: `${SERVER_PATH}/hallTicket/getHallTicketTemplateById`,
    UpdateHallTicketStatus: `${SERVER_PATH}/hallTicket/updateHallTicketStatus`,
    DeleteHallTicketTemplate: `${SERVER_PATH}/hallTicket/deleteHallTicketTemplate`,
    GetHallTicketTemplateListByClassId: `${SERVER_PATH}/hallTicket/getHallTicketTemplateListByClassId`,
    SaveHallTicketBlocks: `${SERVER_PATH}/hallTicket/saveHallTicketBlocks`,
    GetHallTicketBlocks: `${SERVER_PATH}/hallTicket/getHallTicketBlocks`,
    GetHallTicketMeta: `${SERVER_PATH}/hallTicket/getHallTicketMeta`,
    SendHallTicketNotification: `${SERVER_PATH}/hallTicket/sendHallTicketNotification`,

    // Exam Marks
    AddUpdateExamMarks: `${SERVER_PATH}/examMarks/addExamMarksDetail`,
    GetExamMarksList: `${SERVER_PATH}/examMarks/getExamMarksDetailList`,

    //General Configuration
    AddUpdateGeneralConfiguration: `${SERVER_PATH}/general/addGeneralConfigurationDetail`,
    GetGeneralConfigurationDetail: `${SERVER_PATH}/general/getGeneralConfigurationDetail`,
    GetSchoolDashboardData: `${SERVER_PATH}/general/getSchoolDashboardData`,

    //Teacher Dashboard
    GetTeacherDashboardData: `${SERVER_PATH}/teacherDashboard/getTeacherDashboardData`,

    //Fee Structure
    AddUpdateFeeStructure: `${SERVER_PATH}/feeStructure/addFeeStructureDetail`,
    GetFeeStructureList: `${SERVER_PATH}/feeStructure/getFeeStructureDetailList`,
    DeleteFeeStructure: `${SERVER_PATH}/feeStructure/deleteFeeStructureDetail`,

    //Fee Template
    AddFeeTemplate: `${SERVER_PATH}/feeTemplate/addFeeTemplate`,
    GetFeeTemplateList: `${SERVER_PATH}/feeTemplate/getFeeTemplateList`,
    GetFeeTemplateById: `${SERVER_PATH}/feeTemplate/getFeeTemplateById`,
    UpdateFeeTemplateStatus: `${SERVER_PATH}/feeTemplate/updateFeeTemplateStatus`,
    DeleteFeeTemplate: `${SERVER_PATH}/feeTemplate/deleteFeeTemplate`,

    //Fee Collection
    GetStudentFeeCollectionList: `${SERVER_PATH}/feeCollection/getStudentFeeCollectionList`,
    GetStudentFeeDetail: `${SERVER_PATH}/feeCollection/getStudentFeeDetail`,
    CollectFee: `${SERVER_PATH}/feeCollection/collectFee`,
    GetFeeReceipt: `${SERVER_PATH}/feeCollection/getFeeReceipt`,
    GetStudentPaymentHistory: `${SERVER_PATH}/feeCollection/getStudentPaymentHistory`,
    CreateRazorpayOrder: `${SERVER_PATH}/feeCollection/createRazorpayOrder`,
    VerifyRazorpayPayment: `${SERVER_PATH}/feeCollection/verifyRazorpayPayment`,
    SubmitManualPayment: `${SERVER_PATH}/feeCollection/submitManualPayment`,
    GetPendingApprovals: `${SERVER_PATH}/feeCollection/getPendingApprovals`,
    ApproveManualPayment: `${SERVER_PATH}/feeCollection/approveManualPayment`,
    RejectManualPayment: `${SERVER_PATH}/feeCollection/rejectManualPayment`,
    GetParentFeeDetail: `${SERVER_PATH}/feeCollection/getParentFeeDetail`,
    SearchCollectors: `${SERVER_PATH}/feeCollection/searchCollectors`,

    //Payment Config
    AddPaymentConfig: `${SERVER_PATH}/paymentConfig/addPaymentConfig`,
    GetPaymentConfig: `${SERVER_PATH}/paymentConfig/getPaymentConfig`,

    //Announcement
    AddAnnouncement: `${SERVER_PATH}/announcement/addAnnouncement`,
    GetAnnouncementList: `${SERVER_PATH}/announcement/getAnnouncementList`,
    GetAnnouncementById: `${SERVER_PATH}/announcement/getAnnouncementById`,
    GetAnnouncementsForUser: `${SERVER_PATH}/announcement/getAnnouncementsForUser`,
    MarkAnnouncementRead: `${SERVER_PATH}/announcement/markAnnouncementRead`,
    ToggleAnnouncementPin: `${SERVER_PATH}/announcement/togglePin`,
    DeleteAnnouncement: `${SERVER_PATH}/announcement/deleteAnnouncement`,
    GetAnnouncementReadDetails: `${SERVER_PATH}/announcement/getReadDetails`,

    //LMS
    AddLMS: `${SERVER_PATH}/lms/addLms`,
    GetLMSList: `${SERVER_PATH}/lms/getLmsList`,
    GetLMSById: `${SERVER_PATH}/lms/getLmsById`,
    DeleteLMS: `${SERVER_PATH}/lms/deleteLms`,

    //Learning Resources
    GetLearningResources: `${SERVER_PATH}/lms/getLearningResources`,
    DownloadLearningResourcesZip: `${SERVER_PATH}/lms/downloadResourcesZip`,
    DownloadMyResourcesZip: `${SERVER_PATH}/lms/downloadMyResourcesZip`,
    SubmitAssignment: `${SERVER_PATH}/lms/submitAssignment`,
    GetMySubmissions: `${SERVER_PATH}/lms/getMySubmissions`,
    GetAssignmentSubmissions: `${SERVER_PATH}/lms/getAssignmentSubmissions`,
    GradeSubmission: `${SERVER_PATH}/lms/gradeSubmission`,

    //Result Template Configuration
    AddUpdateResultConfiguration: `${SERVER_PATH}/resultConfiguration/addUpdateResultConfiguration`,
    GetResultTemplateConfigurationList: `${SERVER_PATH}/resultConfiguration/getResultConfigurationList`,
    DeleteResultConfiguration: `${SERVER_PATH}/resultConfiguration/deleteResultConfiguration`,

    // Grace Marks Configuration
    AddUpdateGraceMarks: `${SERVER_PATH}/graceMark/addGraceMarksDetail`,
    GetGraceMarksList: `${SERVER_PATH}/graceMark/getGraceMarksDetailList`,

    // Grace Marks Entry
    AddUpdateGraceMarksEntry: `${SERVER_PATH}/graceMarksEntry/addGraceMarksEntryDetail`,
    GetGraceMarksEntryList: `${SERVER_PATH}/graceMarksEntry/getGraceMarksEntryDetailList`,
    GetGraceMarksMasterDetailList: `${SERVER_PATH}/graceMarksEntry/getGraceMarksMasterDetailList`,

    //Password Configuration
    AddUpdatePasswordConfiguration: `${SERVER_PATH}/passwordConfig/addPasswordConfigurationDetail`,
    GetPasswordConfigurationDetail: `${SERVER_PATH}/passwordConfig/getPasswordConfigurationDetail`,

    //Manage Student Photos
    getStudentPhotoManageList: `${SERVER_PATH}/managePhoto/getManageStudentPhotoList`,
    AddUpdateManageStudentPhotos: `${SERVER_PATH}/managePhoto/addUpdateManageStudentPhoto`,
    DeleteManageStudentPhotos: `${SERVER_PATH}/managePhoto/deleteManageStudentPhoto`,
    GetManageStudentMasterDetailList: `${SERVER_PATH}/managePhoto/getManageStudentMasterDetailList`,

    //Notification
    GetNotificationsList: `${SERVER_PATH}/notification/getNotificationDetailList`,
    AddNotification: `${SERVER_PATH}/notification/addNotification`,
    MarkNotificationAsRead: `${SERVER_PATH}/notification/markNotificationAsRead`,
    DeleteNotification: `${SERVER_PATH}/notification/deleteNotification`,
    MarkAllNotificationsAsRead: `${SERVER_PATH}/notification/markAllNotificationsAsRead`,

    // Geofence Configuration
    AddUpdateGeofenceConfiguration: `${SERVER_PATH}/geofenceConfiguration/addGeofenceConfiguration`,
    getGeofenceConfigurationList: `${SERVER_PATH}/geofenceConfiguration/getGeofenceConfigurationList`,
    getGeofenceConfigurationById: `${SERVER_PATH}/geofenceConfiguration/getGeofenceConfigurationById`,
    updateGeofenceConfigurationStatus: `${SERVER_PATH}/geofenceConfiguration/updateGeofenceConfigurationStatus`,
    deleteGeofenceConfiguration: `${SERVER_PATH}/geofenceConfiguration/deleteGeofenceConfiguration`,
    
    // AttendanceType Configuration
    addAttendanceTypeConfiguration: `${SERVER_PATH}/attendanceTypeConfiguration/addAttendanceTypeConfiguration`,
    getAttendanceTypeConfigurationList: `${SERVER_PATH}/attendanceTypeConfiguration/getAttendanceTypeConfigurationList`,
    getAttendanceTypeConfigurationById: `${SERVER_PATH}/attendanceTypeConfiguration/getAttendanceTypeConfigurationById`,
    updateAttendanceTypeConfigurationStatus: `${SERVER_PATH}/attendanceTypeConfiguration/updateAttendanceTypeConfigurationStatus`,
    deleteAttendanceTypeConfiguration: `${SERVER_PATH}/attendanceTypeConfiguration/deleteAttendanceTypeConfiguration`,
  };
}
